"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MFA_TYPES = exports.SORTABLE_USER_COLUMNS_MAP = exports.TIPO_USUARIO = exports.ESTATUS_USUARIO = void 0;
exports.ESTATUS_USUARIO = {
    INACTIVO: 0,
    ACTIVO: 1,
    BLOQUEADO: 2,
};
exports.TIPO_USUARIO = {
    COMUN: 1,
    ADMINISTRADOR: 2,
};
exports.SORTABLE_USER_COLUMNS_MAP = {
    nombre: 'user_nombre',
    direccion: 'user_direccion',
    rut: 'user_rut',
    username: 'user_username',
    email: 'user_email',
    telefono: 'user_telefono',
    estado: 'user_estado',
};
exports.MFA_TYPES = {
    DISABLED: 0,
    EMAIL: 1,
    SMS: 2,
};
